import React from 'react';
import { LastSinistreInfoCard } from 'components/ItemInfoCard';
import { translate } from 'helpers/intl';
import messages from 'containers/AUTODashboard/Body/LastSinister/messages';
import { injectIntl, IntlShape } from 'react-intl';
import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Body/MyContracts/styles';
import { uppercase } from 'utils/string';
import {
  useStyles,
  StyledGrid,
  StyledCard,
} from 'containers/AUTODashboard/Body/LastSinister/styles';
import ItemEmptyState from 'components/ItemEmptyState';
import { CONTRACT_STATUSES } from 'utils/globalConst';
import pages from 'routes/pages';

const LastSinister = ({
  lastSinistre,
  setDetailsPageBreadcrumbsPath,
  ...otherProps
}: {
  intl: IntlShape;
  lastSinistre: any;
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  const classes = useStyles();

  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, otherProps)}
      </StyledSmallSectionHeader>
      {lastSinistre ? (
        <LastSinistreInfoCard
          styles={{ buttonRootStyles: classes.root, icon: 'assitance' }}
          firstInformationLabel={translate(
            { ...messages.dateSinister },
            otherProps,
          )}
          secondInformationLabel={translate(
            { ...messages.numSinister },
            otherProps,
          )}
          buttonLabel={uppercase(
            translate({ ...messages.seeDetails }, otherProps),
          )}
          status={
            lastSinistre.claimStatus === CONTRACT_STATUSES.ACTIVE
              ? 'success'
              : 'warning'
          }
          statusLabel={lastSinistre.claimStatus}
          title={lastSinistre.marque}
          firstInformationValue={lastSinistre.claimLossDate}
          secondInformationValue={lastSinistre.claimNumber}
          redirectionPath={pages.AUTO_DETAILS}
          setDetailsPageBreadcrumbsPath={setDetailsPageBreadcrumbsPath}
        />
      ) : (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate(
                { ...messages.title_sinistre_empty_state },
                otherProps,
              )}
            />
          </StyledGrid>
        </StyledCard>
      )}
    </>
  );
};

export default injectIntl(LastSinister);
